import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { failedResponses } from '../errors/responses';

const c = initContract();

export const ServiceRequestDto = z.object({
  id: z.string(),
  companyId: z.string(),
  requestedBy: z.string(),
  requestType: z.string(),
  createdAt: z.string(),
  customerReference: z.string().optional(),
  payload: z.any()
});

export type ServiceRequestDto = z.infer<typeof ServiceRequestDto>;

export const CreateServiceRequestRequest = z.object({
  requestedBy: z.string(),
  requestType: z.enum(['OffboardUser', 'DeployInventory', 'AdvDeviceReplacement', 'TechRefresh']),
  customerReference: z.string().optional(),
  payload: z.record(z.any())
});

export type CreateServiceRequestRequest = z.infer<typeof CreateServiceRequestRequest>;

export default c.router({
  getServiceRequestTypes: {
    method: 'GET',
    path: '/servicerequesttypes',
    responses: {
      200: z.array(z.string()),
      ...failedResponses
    },
    summary: 'Get dynamic list of service request types'
  },
  getServiceRequests: {
    method: 'GET',
    path: '/msp/:mspId/customers/:customerId/service-requests',
    pathParams: z.object({
      mspId: z.string(),
      customerId: z.string()
    }),
    responses: {
      200: z.array(ServiceRequestDto),
      ...failedResponses
    },
    summary: 'Get service requests for a company'
  },
  createServiceRequest: {
    method: 'POST',
    path: '/msp/:mspId/customers/:customerId/service-requests',
    pathParams: z.object({
      mspId: z.string(),
      customerId: z.string()
    }),
    body: CreateServiceRequestRequest,
    responses: {
      201: ServiceRequestDto,
      200: ServiceRequestDto,
      ...failedResponses
    },
    summary: 'Create a new service request'
  }
});
